import { NgClass, NgIf } from '@angular/common';
import { Component, OnDestroy, OnInit, ViewEncapsulation } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router } from '@angular/router';
import { FuseConfigService } from '@fuse/services/config';
import { environment } from 'environments/environment';
import { Subject } from 'rxjs';

type EnvKey = 'local' | 'dev' | 'preproduction';

const ENV_UI: Record<EnvKey, { label: string; classes: string }> = {
    local: { label: 'LOCAL', classes: 'bg-[#7836FF]' },
    dev: { label: 'DEV', classes: 'bg-[#01172F]' },
    preproduction: { label: 'PRE', classes: 'bg-[#08A4BD]' },
};

@Component({
    selector: 'environment-tag',
    templateUrl: './environment-tag.component.html',
    styles: [
        `
            environment-tag {
                position: static;
                display: block;
                flex: none;
                width: auto;
            }
        `,
    ],
    encapsulation: ViewEncapsulation.None,
    standalone: true,
    imports: [MatIconModule, MatButtonModule, NgClass, MatTooltipModule, NgIf],
})
export class EnvironmentTagComponent implements OnInit, OnDestroy {
    showTag = true;
    tagLabel = '';
    tagClasses = '';

    private _unsubscribeAll: Subject<any> = new Subject<any>();

    constructor(
        private _router: Router,
        private _fuseConfigService: FuseConfigService
    ) {}

    ngOnInit(): void {
        const envKey = ((environment as any)?.name ||
            (environment as any)?.env ||
            'dev') as EnvKey;

        const ui = ENV_UI[envKey] ?? ENV_UI.dev;

        this.tagLabel = ui.label;
        this.tagClasses = ui.classes;
        this.showTag = environment.name !== 'production';
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next(null);
        this._unsubscribeAll.complete();
    }
}
